import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Component, OnInit, Inject, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { ESSENTIALS, MATERIAL_BUTTONS, MATERIAL_LAYOUT } from '../../utils/shared-components';

@Component({
  standalone: true,
  selector: "app-confirm-modal",
  templateUrl: "./confirm-modal.component.html",
  styleUrls: ['./confirm-modal.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ESSENTIALS, MATERIAL_LAYOUT, MATERIAL_BUTTONS],
})
export class ConfirmModalComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConfirmModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) { 

    data.style = data.style ?? "";
    data.confirmText = data.confirmText ?? "Confirmar";
    data.cancelText = data.cancelText ?? "Fechar";

  }

  ngOnInit() {}
}
export interface ConfirmDialogData {
  title: string;
  msg: string;
  style: string;
  confirmText: string;
  cancelText: string;
}


